import type { ReactNode } from 'react';
import { Button } from './button';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from './dialog';

export function ConfirmDialog({
	open,
	onOpenChange,
	title,
	description,
	confirmLabel = 'Delete',
	cancelLabel = 'Cancel',
	variant = 'destructive',
	loading,
	onConfirm,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	/**
	 * A node, not a string: a confirm often has a second thing to say beneath the
	 * question — a server-worded warning about what doing this now costs, which
	 * must be readable at the moment of deciding rather than summarised into it.
	 */
	description: ReactNode;
	confirmLabel?: string;
	cancelLabel?: string;
	variant?: 'destructive' | 'default';
	loading?: boolean;
	onConfirm: () => void;
}) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-sm">
				<DialogHeader className="p-4">
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => onOpenChange(false)}
						disabled={loading}
					>
						{cancelLabel}
					</Button>
					<Button variant={variant} onClick={onConfirm} disabled={loading}>
						{loading ? `${confirmLabel}…` : confirmLabel}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
